var map = {
	"./menu-anydb.avif": 2967,
	"./menu-c-flow.avif": 3705,
	"./menu-customized-software.avif": 9778,
	"./menu-environment-monitoring-system.avif": 5059,
	"./menu-erp-solutions.avif": 931,
	"./menu-file-cloud.avif": 7547,
	"./menu-it-network-monitoring.avif": 7420,
	"./menu-it-solutions.avif": 3369,
	"./menu-ivisita.avif": 5862,
	"./menu-meeting-room.avif": 6542,
	"./menu-mobile-application-development.avif": 3804,
	"./menu-paperless-meeting.avif": 7848,
	"./menu-web-application-development.avif": 822,
	"./menu-weeds.avif": 1713,
	"./programming-background-with-person-working-with-codes-computer.avif": 166
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4123;